<div class="content" [class.disabled]="disabled">
  <app-material-image class="image"
                      [padding]="true"
                      [src]="reservation.cover"
                      [type]="reservation.recordType"
                      [state]="reservation.state"></app-material-image>
  <div class="bibliograpic-info">
    <div class="head">
      <span class="dk5">{{reservation.dk5}}</span>
      <app-material-image [type]="reservation.recordType"></app-material-image>
      <mat-icon *ngIf="reservation.illReservation" svgIcon="material-types/ill"></mat-icon>
      <span class="fill"></span>
      <div class="age" [class.yellow]="reservation.reservationAge === 2" [class.red]="reservation.reservationAge === 3"></div>
    </div>
    <div *ngIf="reservation.author && !reservation.periodicalInformation" class="author truncate">{{reservation.author}}</div>
    <div class="periodicalInformation truncate">{{reservation.periodicalInformation}}</div>
    <div class="title">{{reservation.title}}</div>
    <div class="faust truncate">
      {{reservation.faustNumber}}<span *ngIf="reservation.materialNumber">/<span class="material-number">{{reservation.materialNumber}}</span></span>
      <span *ngIf="reservation.numberOfpages"> - {{reservation.numberOfpages}}</span>
      <span *ngIf="reservation.publishedInYear"> - {{reservation.publishedInYear}}</span>
    </div>
    <div class="placement truncate">{{reservation.materials[0].placementInfo}}</div>
  </div>
</div>
<div class="details" [class.disabled]="disabled" *ngIf="expanded">
  <div class="reservation-date">
    <strong>Reserveret</strong> {{reservation.reservationDate | dateTimeOffSetPipe | cuiDateOrTimeToday}}
  </div>

  <table>
    <thead>
    <tr>
      <th class="truncate">Placering</th>
      <th class="truncate">Materialenr.</th>
      <th class="truncate">Sidst aflv.</th>
      <th></th>
    </tr>
    </thead>
    <tbody class="vertical-align-top">
    <tr *ngFor="let material of reservation.materials">
      <td>{{material.placementInfo}}</td>
      <td>{{material.materialNumber}}</td>
      <td>{{material.materialLogActionTime  | dateTimeOffSetPipe | cuiDateOrTimeToday}}{{material.materialLogActionUser ? ' af ' +
        material.materialLogActionUser : ''}}
      </td>
    </tr>
    </tbody>
  </table>
</div>



// WEBPACK FOOTER //
// ./src/app/pick-up-list/reservation/reservation.component.html